import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { ConfirmProvider } from "./components/ui/ConfirmDialog.js";
import { UnsavedChangesProvider } from "./components/UnsavedChangesProvider.js";
import { APP_VERSION, installFeedbackQueueListeners } from "./lib/feedback/client.js";
import { applyFontScale, getFontScale } from "./lib/displayPrefs.js";
import "./index.css";

document.documentElement.dataset.appVersion = APP_VERSION;
installFeedbackQueueListeners();
// Applied before first render so there's no flash of unscaled text for
// users who've already picked a larger size (see lib/displayPrefs.ts).
applyFontScale(getFontScale());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ConfirmProvider>
        <UnsavedChangesProvider>
          <App />
        </UnsavedChangesProvider>
      </ConfirmProvider>
    </BrowserRouter>
  </StrictMode>
);
